<template>
  <div class="test">
    <IndexNav></IndexNav>
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <label class="font-readex font-weight-bold">Vyberte si svůj jídelníček</label>
            <v-select
              v-model="selectedDiet"
              :items="diets"
              item-text="name"
              return-object
              outlined
              rounded
              style="font-size: 0.85em"
              color="darkGreen"
              item-color="lightGreen"
              hide-details
              class="rounded-lg text-uppercase font-readex bg-white font-weight-bold"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <label class="font-readex font-weight-bold">Vyberte si datum</label>
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="selectedDate"
                transition="scale-transition"
                offset-y
                class="elevation-0"
                max-width="350"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    v-model="selectedDate"
                    hide-details
                    color="darkGreen"
                    class="rounded-lg font-readex bg-white"
                    rounded
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
              <v-date-picker
                v-model="selectedDate"
                color="green lighten-1"
                :min="minDate"
                width="350"
                locale="cs-cz"
                first-day-of-week="1"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  class="btn btn-red-gradient"
                  dark
                  @click="menu = false"
                >
                  Zrušit
                </v-btn>
                <v-btn
                  dark
                  color="darkGreen"
                  class="btn btn-green-gradient"
                  @click="$refs.menu.save(selectedDate)"
                >
                  Vybrat
                </v-btn>
              </v-date-picker>
              </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col :key="index" v-for="(time, index) in timeTypes" cols="12" >
            <v-card v-if="availableFood[index].length" elevation="0" style="background-color: inherit">
              <h2 class="font-readex text-left text-darkGreen text-uppercase font-weight-bold mb-3" style="font-size: 1em">{{time.name}}</h2>
              <v-simple-table
                class="stripedDT lightYellow rounded-lg"
              >
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-darkGreen font-weight-bold text-uppercase text-left">
                      Název
                    </th>
                    <th class="font-weight-bold text-uppercase text-right">
                      Cena
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="item in availableFood[index]"
                    :key="item.id"
                  >
                    <td class="text-darkGreen font-readex font-weight-bold text-left">{{ item.name }}</td>
                    <td class="text-black font-readex font-weight-bold text-uppercase text-right">{{ item.price }} Kč</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-footer id="footer">
        <v-container id="gopay">
          <h3 class="font-weight-bold font-poppins-heading">Kontakt</h3>
          <v-row class="align-items-flex-end">
            <v-col cols="12" md="4">
              <p>
                Vegamenu s.r.o.<br>
                IČ: 02594757 <br>DIČ: CZ02594757<br>
                Jarmily Glazarové 354/9j <br>779 00 Olomouc
              </p>
            </v-col>
            <v-col cols="12" md="4">
              <p>
                objednavky@vegamenu.cz<br>
                778 434 090<br>
                733 303 839<br>
                <a href="./vop.pdf" target="_blank" id="test-front">Obchodní podmínky a GDPR</a>
              </p>
            </v-col>
            <v-col cols="12" md="4">
              <v-img src="@/assets/VM-logo-transparent.png"></v-img>
            </v-col>
          </v-row>
          <v-row class="v-row">
            <v-col>
              <v-img src="@/assets/gp-bily.png" class="v-col" cols="1"></v-img>
            </v-col>
            <v-col>
              <v-img src="@/assets/img.png" class="v-col" cols="1"></v-img>
            </v-col>
            <v-col>
              <v-img src="@/assets/1.png" class="v-col" cols="1"></v-img>
            </v-col>
            <v-col>
              <v-img src="@/assets/2.png" class="v-col" cols="1"></v-img>
            </v-col>
            <v-col>
              <v-img src="@/assets/3.png" class="v-col" cols="1"></v-img>
            </v-col>
            <v-col>
              <v-img src="@/assets/4.png" class="v-col" cols="1"></v-img>
            </v-col>
            <v-col>
              <v-img src="@/assets/5.png" class="v-col" cols="1"></v-img>
            </v-col>
          </v-row>
          <div class="text-center">JKTech IT Solutions s.r.o. &copy; {{ new Date().getFullYear() }}</div>
        </v-container>
      </v-footer>
    </v-main>
  </div>
</template>

<script>
import IndexNav from '@/views/IndexNav'
export default {
  name: 'Index',
  components: { IndexNav },
  data () {
    return {
      minDate: new Date().toISOString().slice(0, 10),
      selectedDiet: null,
      selectedDate: new Date().toISOString().substr(0, 10),
      availableDiets: [],
      availableFood: [[], [], [], [], [], []],
      timeTypes: [],
      menu: false,
      dietVmId: null
    }
  },
  methods: {
    initialize () {
      this.$http.get('/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/diets/publicly-accessible')
        .then(response => {
          this.availableDiets = this.keysToCamelCase(response.data)
            .filter(diet => diet.active === 1)
        })
        .catch(err => { console.log(err) })
    },
    getDietDay () {
      if (this.selectedDiet) {
        this.$http.get(`/diets/${this.selectedDiet.id}/days/date/${this.selectedDate}`)
          .then(response => {
            const res = this.keysToCamelCase(response.data)
            this.availableFood = [[], [], [], [], [], []]

            let dietDayItems = []
            if (Object.keys(res).length) {
              dietDayItems = res.dietDayItems
            }

            const items = dietDayItems.map(item => {
              item = { ...item, ...item.eatable }
              item.alergensStr = item.alergens
                .map(alergen => alergen.name)
                .join(', ')
              return item
            })
            this.availableFood = this.availableFood.map((time, index) => {
              return items.filter(item => item.timeId === index + 1)
            })
          })
          .catch(err => { console.log(err) })
      }
    },
    getVMDay () {
      this.dietVmId = this.availableDiets.filter(diet => {
        if (diet.name === 'Vegamenu') {
          return diet
        }
      })
      // this.selectedDiet = this.dietVmId
      this.$http.get(`/diets/${this.dietVmId[0].id}/days/date/${this.selectedDate}`)
        .then(response => {
          const res = this.keysToCamelCase(response.data)
          this.availableFood = [[], [], [], [], [], []]

          let dietDayItems = []
          if (Object.keys(res).length) {
            dietDayItems = res.dietDayItems
          }

          const items = dietDayItems.map(item => {
            item = { ...item, ...item.eatable }
            item.alergensStr = item.alergens
              .map(alergen => alergen.name)
              .join(', ')
            return item
          })
          this.availableFood = this.availableFood.map((time, index) => {
            return items.filter(item => item.timeId === index + 1)
          })
        })
        .catch(err => { console.log(err) })
    }
  },
  created () {
    this.initialize()
    setTimeout(() => {
      this.getVMDay()
    }, 1000)
  },
  watch: {
    selectedDate () {
      this.getDietDay()
    },
    selectedDiet () {
      this.getDietDay()
    }
  },
  computed: {
    diets () {
      const selectedD = new Date(this.selectedDate).getTime()

      return this.availableDiets.filter(diet => {
        const dietFromDate = new Date(diet.dateFrom).getTime()
        const dietToDate = new Date(diet.dateTo).getTime()

        return !!(selectedD >= dietFromDate && selectedD <= dietToDate)
      })
    }
  }
}
</script>

<style scoped>
h2, h3{
  color: var(--v-darkGreen-base);
  font-weight: 500;
  font-size:1.2rem;
  text-align: center;
}
h3{
  font-size: 1.5rem;
}
#footer{
  margin-top: 40vh;
  font-family: "Readex Pro", sans-serif;
}
#footer .v-col{
  max-width: 75px;
  text-align: center;
}
#gopay{
  width: 50%;
}
@media screen and (max-width: 756px) {
  #gopay{
    width: 75%;
  }
}
.test{
  height: 100vh;
  background-color:#f9f9fb ;
}
.align-items-flex-end{
  align-items: flex-end;
}
</style>
